import { Component } from '@angular/core';

@Component({
  selector: 'blank-screen',
  imports: [],
  templateUrl: './blank-screen.component.html',
  standalone: true,
  styleUrl: './blank-screen.component.scss'
})
export class BlankScreenComponent {}
